
import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs';
import { ActionRecommendationAttachRulesViewModel, ActionRecommendationAttachRuleViewModel } from '../action-recommendations.model';
import { ActionRecommendationService } from '../action-recommendations.service';


@Component({
  selector: 'action-recommendation-attach-rules',
  templateUrl: './action-recommendation-attach-rules.component.html',
  styleUrls: ['./action-recommendation-attach-rules.component.scss']
})
export class ActionRecommendationAttachRulesComponent implements OnInit {
  @Output() reloadSelectedQuote: EventEmitter<any> = new EventEmitter();
  @Input() inspectionId: number;
  @Input() quoteId: number;
  @Input() StartSMU: number;

  RuleDetails: ActionRecommendationAttachRulesViewModel[] = [];
  componentId: number;
  constructor(
    private _RuleService: ActionRecommendationService,
    private _notify: NotificationsService
  ) { }

  ngOnInit() {
    this.getRulesToAttach();
  }

  getRulesToAttach() {
    this._RuleService.GetActionRecommendationRulesAndDetails(this.inspectionId, this.quoteId).subscribe(rec => {
      this.RuleDetails = rec;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendation. Please contact TrackTreads support!!');
      console.error(err);
    });
  }

  attachRuleComponent(ruleSelected: boolean, ruleDetailId: number) {
    if (ruleSelected) {
      if (this.StartSMU == undefined || this.StartSMU == 0) {
        this.RuleDetails.filter(x => x.RuleComponentId === ruleDetailId)[0].RuleSelected = false;
        this._notify.error('Error', 'Unable to add recommendation. Please enter SMU!!');
      }
      else {
        const VM = new ActionRecommendationAttachRuleViewModel();
        VM.RuleDetailId = ruleDetailId;
        VM.InspectionId = this.inspectionId;
        VM.StartSMU = this.StartSMU;
        VM.QuoteId = this.quoteId;
        this._RuleService.AttachActionRecommendationRule(VM).subscribe(rec => {
          //this.RuleDetails = rec;
          if (rec == 0) {
            this._notify.success('Added', "Rule attached successfully.");
            this.getRulesToAttach();
          }
          else if (rec == 1) {
            this._notify.error('Failed', "Unable to add recommendation. No such component found!!");
            this.RuleDetails.filter(x => x.RuleComponentId === ruleDetailId)[0].RuleSelected = false;
          }
          else if (rec == 2) {
            this._notify.error('Error', "Unable to add recommendation.Please contact TrackTreads support!!");
            this.RuleDetails.filter(x => x.RuleComponentId === ruleDetailId)[0].RuleSelected = false;
          }
          this.reloadSelectedQuote.emit({
            quoteId: this.quoteId,
            recommendationId: 1
          });
        }, err => {
          this._notify.error('Error', 'Unable to add recommendation. Please contact TrackTreads support!!');
          this.RuleDetails.filter(x => x.RuleComponentId === ruleDetailId)[0].RuleSelected = false;
        });
      }
    }

  }

}
